module.exports = __webpack_public_path__ + "assets/decorazione_up.e4ff240a.svg";